import { layout } from 'src/components/base';
import { Button } from '@prisjakt/ui/button';
import { IconOutgoingLink } from '@prisjakt/ui/icon/outgoing-link';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ICON_SIZE = 15;

type Props = {
  className?: string;
  href: string | null;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  containerProps?: {};
  external?: boolean;
  text: string;
};

export const NewClickOutButton: React.FC<Props> = ({
  className,
  containerProps,
  href,
  onClick,
  external,
  text,
}) => {
  const linkProps = external
    ? {
        href,
        rel: 'nofollow',
        target: '_blank',
      }
    : {
        to: href,
      };

  return (
    <OuterWrapper>
      <Button
        className={className}
        containerProps={{
          ...containerProps,
          ...linkProps,
        }}
        container={external ? 'a' : Link}
        disabled={!href}
        onClick={onClick}
        fullWidth
      >
        <InnerWrapper>
          {`${text} `}
          {external && (
            <IconWrapper>
              <IconOutgoingLinkWithColorFix size={ICON_SIZE} />
            </IconWrapper>
          )}
        </InnerWrapper>
      </Button>
    </OuterWrapper>
  );
};

const OuterWrapper = styled.div`
  height: 42px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

const IconWrapper = styled.div`
  margin-left: ${layout.measurements.spacing025};
  & > * {
    vertical-align: middle;
  }
`;

const InnerWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
`;

const IconOutgoingLinkWithColorFix = styled(IconOutgoingLink)`
  & > path {
    fill: currentColor;
  }
`;
